import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface Url {
  title: string;
  url: string;
}
interface Props {
  title: string;
  description: string;
  subDescription: string;
  urls: Url[];
  img: string;
  youtube?: string;
  onlyPc?: boolean;
}

function GuideBox({
  title,
  description,
  subDescription,
  urls,
  img,
  youtube,
  onlyPc,
}: Props) {
  const navigate = useNavigate();
  return (
    <Box gap={14}>
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
      {subDescription && <Subdescription>{subDescription}</Subdescription>}
      {onlyPc ? (
        <PCBox>
          <img
            src="/assets/images/icon/info-gray.svg"
            alt=""
            width={14}
            height={14}
          />
          해당 기능은 현재 PC에서만 가능합니다.
        </PCBox>
      ) : (
        <ButtonBox>
          {urls.length > 0 &&
            urls.map(({ title, url }) => (
              <Button key={url} onClick={() => navigate(url)}>
                {title} 바로가기
                <img
                  src="/assets/images/arrow/Arrow-right-white.svg"
                  alt=""
                  width={16}
                  height={16}
                />
              </Button>
            ))}
        </ButtonBox>
      )}
      {youtube && (
        <IframeWrapper>
          {/* <iframe src={youtube} width="100%" height="185" /> */}
          <div style={{ width: '100%', aspectRatio: '328 / 185' }}>
            <iframe
              src={youtube}
              width="100%"
              height="100%"
              style={{ border: 'none' }}
              allowFullScreen
            />
          </div>
        </IframeWrapper>
      )}
      {img && <img src={img} alt="" style={{ width: '100%' }} />}
    </Box>
  );
}

export default GuideBox;

const Box = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => `${gap}px`};
`;

const Title = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const Description = styled.div`
  white-space: pre-line;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const Subdescription = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 13px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow-x: auto;

  /* 스크롤바 숨기기 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE, Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
`;

const Button = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  padding: 7px 3px 7px 8px;
  background-color: #008aff;
  cursor: pointer;
  border: none;
  gap: 2px;
  white-space: nowrap;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #ffffff;
`;

const IframeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PCBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px;
  padding: 12px 16px;
  gap: 4px;
  background-color: #70737c0d;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 13px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;
